/*
 * Resolution
 *
 * Author: Anthony LEFOYE
 * Copyright (c) 2022 Prodeo - All Rights Reserved
 */

'use strict';

class Constants {
  static version = {
    major: 1,
    minor: 15,
    revision: 2,
    toString: '1.15.2'
  };

  static app = {
    name: 'Résolution'
  };

  static localization = {
    locales: [ 'fr' ],
    default_locale: 'fr'
  };

  static database = {
    date_format: 'YYYY-MM-DD',
    datetime_format: 'YYYY-MM-DD HH:mm:ss.SSS'
  };

  static history = {
    add: 'ADD',
    delete: 'DEL',
    update: 'UPD'
  };

  static INT = {
    MAX: 2147483647,
    MIN: -2147483647
  };

}

Object.defineProperty( Constants.version, 'major', { value: Constants.version.major, writable: false } );
Object.defineProperty( Constants.version, 'minor', { value: Constants.version.minor, writable: false } );
Object.defineProperty( Constants.version, 'revision', { value: Constants.version.revision, writable: false } );
Object.defineProperty( Constants.version, 'toString', { value: Constants.version.toString, writable: false } );
Object.defineProperty( Constants.app, 'name', { value: Constants.app.name, writable: false } );
Object.defineProperty( Constants.localization, 'locales', { value: Constants.localization.locales, writable: false } );
Object.defineProperty( Constants.localization, 'default_locale', { value: Constants.localization.default_locale, writable: false } );
Object.defineProperty( Constants.database, 'date_format', { value: Constants.database.date_format, writable: false } );
Object.defineProperty( Constants.database, 'datetime_format', { value: Constants.database.datetime_format, writable: false } );
Object.defineProperty( Constants.history, 'add', { value: Constants.history.add, writable: false } );
Object.defineProperty( Constants.history, 'delete', { value: Constants.history.delete, writable: false } );
Object.defineProperty( Constants.history, 'update', { value: Constants.history.update, writable: false } );
Object.defineProperty( Constants.INT, 'MAX', { value: Constants.INT.MAX, writable: false } );
Object.defineProperty( Constants.INT, 'MIN', { value: Constants.INT.MIN, writable: false } );

module.exports = Constants;